<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
>
  <!-- <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div> -->
  <div fxFlex="25%">{{ app?.appConfigId }}</div>
  <div fxFlex="25%">{{ app?.appConfigDescription }}</div>
  <div
    fxFlex="45%"
    *ngIf="app?.appConfigId === 'TWO_FACTOR_AUTH_ACTIVATION_DATE'"
  >
    {{ app?.appConfigValue | date }}
  </div>
  <div
    fxFlex="45%"
    *ngIf="app?.appConfigId !== 'TWO_FACTOR_AUTH_ACTIVATION_DATE'"
  >
    {{ app?.appConfigValue }}
  </div>
  <div fxFlex="5%" class="text-right">
    <button
      *isPermitted="{ id: 'APPLICATION_CONFIG', action: 'edit' }"
      class="ui circular tiny button"
      (click)="onEdit.emit(app)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Edit Configuration"
    >
      <i class="pencil icon"></i>
    </button>
    <!-- <button  *isPermitted="{id:'APPLICATION_CONFIG',action:'edit'}"  class="ui circular tiny button" (click)="onDelete.emit(app)"><i class="trash icon"></i></button> -->
    <!-- <a class="ui circular tiny button" routerLink="/admin/setting/app-config/{{app.id}}"><i class="eye icon"></i></a> -->
  </div>
</div>
